import { DadosTributacao } from "app/types/produto/RespostaTributacao";
import globalMU from "globalMU";
import React from "react";

const estiloFormulario =
  require("./../../../estilos/formulario.module.scss").default;

export type TributacaoProps = {
  dadosTributacao: DadosTributacao;
  produto: string;
  descricao: string;
};

export const Tributacao = (props: TributacaoProps) => {
  return (
    <>
      <div className={estiloFormulario.gridDuasColunas}>
        <div>Produto</div>
        <div>{props.produto}</div>

        <div>Descrição</div>
        <div>{props.descricao}</div>

        <div>Classificação Fiscal </div>
        <div>{props.dadosTributacao?.ClassificaoFiscal}</div>
  
        <div>Substituição Tributária Compra</div>
        <div>{props.dadosTributacao?.TemSubstituicaoTributariaEntrada}</div>

        <div>Substituição Tributária Venda</div>
        <div>{props.dadosTributacao?.TemSubstituicaoTributariaSaida}</div>

        <div>Alíquota IPI</div>
        <div>{globalMU.formatarValorNumerico(props.dadosTributacao?.AliquotaIpi, 2)}</div>

        <div>Código Mensagem Contribuinte</div>
        <div>
          {props.dadosTributacao?.CodigoMensagemContribuinte} -{" "}
          {props.dadosTributacao?.DescricaoMensagemContribuinte}
        </div>

        <div>Base ICMS Contribuinte </div>
        <div>
          {globalMU.formatarValorNumerico(props.dadosTributacao?.BaseIcmsContribuinte, 2)}
        </div>

        <div>Alíquota ICMS Contribuinte</div>
        <div>
          {globalMU.formatarValorNumerico(props.dadosTributacao?.AliquotaIcmsContribuinte, 2)}
        </div>

        <div>Código Mensagem Não Contribuinte</div>
        <div>
          {props.dadosTributacao?.CodigoMensagemNaoContribuinte} -{" "}
          {props.dadosTributacao?.DescricaoMensagemNaoContribuinte}
        </div>

        <div>Base ICMS Não Contribuinte</div>
        <div>
          {globalMU.formatarValorNumerico(props.dadosTributacao?.BaseIcmsContribuinte, 2)}
        </div>

        <div>Alíquota ICMS Não Contribuinte</div>
        <div>
          {globalMU.formatarValorNumerico(props.dadosTributacao?.AliquotaIcmsNaoContribuinte, 2)}
        </div>
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
